import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import LabelText from '../LabelText';

const Name = (props) => {
	const { t, i18n } = useTranslation();

	const {form_component} = props;

	const fv = useSelector(state => state.fv);
	const lineUserData = useSelector(state => state.lineUserData);
	const userData = useSelector(state => state.userData);

	const [inputValue, setInputValue] = useState('');

	useEffect(() => { // to be updated after render
		if (fv && form_component.required) {
			fv.addField('name', {
				validators: {
					notEmpty: {
						message: t('此欄為必須填寫')
					}
				}
			});
		}
	}, [fv]);

	useEffect(() => { // to be updated after render
		if (userData && userData.name) {
			setInputValue(userData.name);
		} else if (lineUserData.nickname) {
			setInputValue(lineUserData.nickname);
		}
	}, [lineUserData, userData]);

	const onChange = (e) => {
		setInputValue(e.target.value);
	}

	return (
		<div className={`flex-grow-1 form-group text ${form_component.required ? 'required' : ''}`}>
			<LabelText
				lang={props.lang}
				form_component={form_component}
			/>
			<input
				type="text"
				name="name"
				placeholder={form_component.default_text_type === 'placeholder' ? form_component.default_text : ''}
				className="form-control-sm mb-3 form-control"
				id="name"
				value={inputValue}
				onChange={onChange}
			/>
		</div>
	);
}

export default Name;